import { Component, Injector, AfterViewInit, ElementRef, EventEmitter, Input, OnInit, Output, NgModule, Renderer, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { Translations } from './grid.translation';
import { UiComponent } from '../ui/ui.component';
import { GridService } from './grid.service';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
import { DataService } from '../../services/data/data.service';
import { ReactiveformService } from '../../services/reactiveform/reactiveform.service';

import { Item } from './item';
import { Column } from './column';
import { Error } from './error';
import { PaginationService } from '../../services/pagination/pagination.service';
import { DebounceinputComponent } from '../debounceinput/debounceinput.component';

import { GridRoutingModule } from './grid.routing.module';
import {
  FilterArrayPipe,
  OrderBy
} from './grid.pipe';

declare const $: any;
const offsetDefault: number = 30;

// ng2FileDrop (fileOver)="uploadFile($event)" [uploader]="uploader"

@Component({
  selector: 'grid',
  template: `
  <div class="card" *ngIf="visible && ((openMode == 2 && parentId > 111) || (openMode == 1))" [ngClass]="{'card-modal': modal}">
    <div class="card-header grid-header">
      <div class="grid-card-title float-left">
        <span class="badge blue" style="background-color: #007bff!important;">{{items.length}}</span>
        <debounceinput style="max-width: 150px;" [(inputValue)]="listFilter" (updated)="filterChange($event)" (keypress)="onKeyPress($event)"
        [placeholder]="title" #filterinput></debounceinput>
      </div>
      <div class="text-right">
        <a *ngIf="selectMultiple && getItemSelected().length > 0 " class="navbar-btn waves-effect waves-light" (click)="getItem(getItemSelected())">
          <i class="fa fa-reply-all fa-lg"></i>
        </a>
        <span *ngIf="selectMultiple && getItemSelected().length > 0" class="counter">{{getItemSelected().length}}</span>
        <div class="btn-group" style="display: initial;">
          <a *ngIf="showCreate && !createChoices" class="navbar-btn waves-effect waves-light" data-toggle="tooltip" title="{{ ui.create }}"
          (click)="onCreate()">
            <i class="fa fa-plus fa-lg"></i>
          </a>
          <a *ngIf="showCreate && createChoices" class="navbar-btn waves-effect waves-light" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
            <i class="fa fa fa-plus fa-lg" data-toggle="tooltip" title="{{ ui.create }}"></i>
            <span class="sr-only"></span>
          </a>
          <div *ngIf="createChoices" class="dropdown-menu">
            <button style="cursor:pointer" *ngFor="let createChoice of createChoices" class="dropdown-item" (click)="onCreateParameters(createChoice)">{{createChoice.caption}}</button>
          </div>
        </div>
        <span *ngFor="let action of actions">
          <a *ngIf="action.show || getItemSelected().length > 0" class="navbar-btn waves-effect waves-light" (click)="action.function()">
            <i class="{{action.glyph}} fa-lg"></i>
          </a>
          <span *ngIf="!action.show && getItemSelected().length > 0" style="background-color: #ab47bc" class="counter">
            <b>{{getItemSelected().length}}</b>
          </span>
        </span>
        <a class="navbar-btn waves-effect waves-light" data-toggle="tooltip" title="{{ ui.delete }}" (click)="deleteItemSelected()"
        *ngIf="showDelete && getItemSelected().length > 0">
          <i class="fa fa-minus fa-lg"></i>
        </a>
        <span *ngIf="getItemSelected().length > 0" class="counter">{{getItemSelected().length}}</span>
        <a #btnClose *ngIf="modal" data-toggle="tooltip" title="{{ ui.close }}" class="navbar-btn waves-effect waves-light" (click)="closeModal()">
          <i class="fa fa-window-close fa-lg"></i>
        </a>
      </div>
    </div>
    <div id="grid{{name}}" class="card-block grid-card-block collapse panel-collapse show" role="tabpanel">
      <div *ngIf="showFilter">
        <div class="col-12 grid-card" style="padding-top:.75rem;padding-bottom:.75rem;">
          <div style="overflow-x: auto; max-height: 165px;">
            <table class="table-hover">
              <thead>
                <tr>
                  <th style="margin: 0 0 0 .75rem;">Created Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="cursor: pointer;" (click)="getItemsFromFilter(0)">Last Hour
                    <i *ngIf="filterOption.date == 0" class="fa fa-remove" style="padding-left: 2rem;color:rgba(0, 0, 0, 0.54) !important"></i>
                  </td>
                </tr>
                <tr>
                  <td style="cursor: pointer;" (click)="getItemsFromFilter(1)">Today
                    <i *ngIf="filterOption.date == 1" class="fa fa-remove" style="padding-left: 2rem;color:rgba(0, 0, 0, 0.54) !important"></i>
                  </td>
                </tr>
                <tr>
                  <td style="cursor: pointer;" (click)="getItemsFromFilter(2)">This week
                    <i *ngIf="filterOption.date == 2" class="fa fa-remove" style="padding-left: 2rem;color:rgba(0, 0, 0, 0.54) !important"></i>
                  </td>
                </tr>
                <tr>
                  <td style="cursor: pointer;" (click)="getItemsFromFilter(3)">This month
                    <i *ngIf="filterOption.date == 3" class="fa fa-remove" style="padding-left: 2rem;color:rgba(0, 0, 0, 0.54) !important"></i>
                  </td>
                </tr>
                <tr>
                  <td style="cursor: pointer;" (click)="getItemsFromFilter(4)">This year
                    <i *ngIf="filterOption.date == 4" class="fa fa-remove" style="padding-left: 2rem;color:rgba(0, 0, 0, 0.54) !important"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-hover" *ngIf="error != null && error.errorList != null">
          <thead>
            <tr class="bg-danger">
              <th>Code</th>
              <th>Description</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let error of items.errorList">
              <td>{{error.code}}</td>
              <td>{{error.description}}</td>
              <td>{{error.url}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive" *ngIf="error && (items | filter:listFilter.value).length">
        <h3 align="center">No {{title}}</h3>
      </div>
      <div class="row d-md-none grid-sm-row" style="display: flex;justify-content: center;">
        <div *ngFor="let item of items ; let i = index" class="col-12 col-sm-6 grid-card" style="cursor: pointer; " (click)="getItem([item])">
          <div class="card">
            <div class="card-header grid-small-device white-text" style="background-color: #007bff; text-align: center;">
              <fieldset [ngSwitch]="columns[0].datatype">
                <b *ngSwitchCase="0">{{returnData(item,columns[0])}}</b>
                <span *ngSwitchCase="1">
                  <moment date="{{returnData(item,columns[0])}}"></moment>
                </span>
                <span *ngSwitchCase="2">
                  <input type="checkbox" id="columns[0].fieldName{{i}}" [(ngModel)]="item[columns[0]]">
                  <label attr.for="columns[0].fieldName{{i}}"></label>
                </span>
                <span *ngSwitchCase="3">
                  <state [item]="item" value="{{returnData(item,columns[0])}}" [options]="columns[0].options"></state>
                </span>
                <span *ngSwitchCase="4">
                  <glyph [item]="item" value="{{returnData(item,columns[0])}}" [options]="columns[0].options"></glyph>
                </span>
                <span *ngSwitchCase="5">
                  <a href="{{returnData(item,columns[0])}}" target="_blank">{{returnData(item,columns[0])}}</a>
                </span>
                <span *ngSwitchCase="6">
                  <a href="tel:{{returnData(item,columns[0])}}">{{returnData(item,columns[0])}}</a>
                </span>
              </fieldset>
            </div>
            <div *ngIf="columnsVisible.length > 1 " class="card-block grid-small-device">
              <div style="overflow-x: auto; max-height: 105px;">
                <table>
                  <tr *ngFor="let column of columnsVisible ; let j = index">
                    <td *ngIf="j != 0" class="grid-col-header">
                      <b>{{column.caption}}</b>
                    </td>
                    <td *ngIf="j != 0" class="" style="width: 100%;">
                      <fieldset [ngSwitch]="column.datatype">
                        <div class="grid-col-data" *ngSwitchCase="0">{{returnData(item,column)}}</div>
                        <span *ngSwitchCase="1">
                          <moment date="{{returnData(item,column)}}"></moment>
                        </span>
                        <span *ngSwitchCase="2">
                          <input type="checkbox" id="column.fieldName{{i}}" [(ngModel)]="item[column]">
                          <label attr.for="column.fieldName{{i}}"></label>
                        </span>
                        <span *ngSwitchCase="3">
                          <state [item]="item" value="{{returnData(item,column)}}" [options]="column.options"></state>
                        </span>
                        <span *ngSwitchCase="4">
                          <glyph [item]="item" value="{{returnData(item,column)}}" [options]="column.options"></glyph>
                        </span>
                        <span *ngSwitchCase="5">
                          <a href="{{returnData(item,column)}}" target="_blank">{{returnData(item,column)}}</a>
                        </span>
                        <span *ngSwitchCase="6">
                          <a href="tel:{{returnData(item,column)}}">{{returnData(item,column)}}</a>
                        </span>
                        <span *ngSwitchCase="10" class="flex-{{column.align}}">
                          <i class="fa-2x" [ngClass]="returnData(item,column)"></i>
                        </span>
                        <span *ngSwitchCase="11" class="flex-{{column.align}}">
                          <span style="height:100%;width: 100%;display:block;overflow:auto;" [ngStyle]="{'background-color': '#' + returnData(item,column)}">&nbsp;</span>
                        </span>
                      </fieldset>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!error && items.length == 0" style="padding-left: .6rem;color: gray;">
        Aucun enregistrement
      </div>
      <div class="table-responsive d-none d-md-block" style="overflow: auto" (window:scroll)="onScroll($event)" *ngIf="!error && (!loading || infinite) && items.length > 0">
        <table class="table table-hover table-sm mb-1">
          <thead>
            <tr>
              <th *ngIf="selectMultiple || !modal" class="grid-checkbox" style="width: 35px;">
                <fieldset style="padding-right: 12px;" class="form-group">
                  <input type="checkbox" id="selectedAll{{name}}" (click)="onselectAll()" [(ngModel)]="selectAll">
                  <label for="selectedAll{{name}}"></label>
                </fieldset>
              </th>
              <th *ngFor="let column of columnsVisible" class="text-truncate text-{{column.align}}">
                <a (click)="onOrderBy(column)" *ngIf="column.orderBy==0">{{column.caption}}
                  <i class="fa fa-sort" style="color: lightgrey"></i>
                </a>
                <a (click)="onOrderBy(column)" *ngIf="column.orderBy==1">{{column.caption}}
                  <i class="fa fa-sort-asc" style="color: red"></i>
                </a>
                <a (click)="onOrderBy(column)" *ngIf="column.orderBy==2">{{column.caption}}
                  <i class="fa fa-sort-desc" style="color: red"></i>
                </a>
              </th>
            </tr>
          </thead>
          <tfoot *ngIf="footerVisible">
            <tr>
              <td></td>
              <td *ngFor="let column of columnsVisible">
                <div class="text-right" *ngIf="column.datatype == 8">
                  {{ufColumnSum(column)}}
                </div>
              </td>
            </tr>
          </tfoot>
          <tbody>
            <tr *ngFor="let item of items ; let i = index" (click)="onSelect(item)">
              <td *ngIf="(selectMultiple || !modal) && (offset == 0 || i < offset)" style="width: 35px;">
                <fieldset class="form-group">
                  <input type="checkbox" id="{{name}}checkbox{{i}}" [(ngModel)]="item.selected" [disabled]="item.locked">
                  <label attr.for="{{name}}checkbox{{i}}" [ngClass]="{disabled:item.locked}"></label>
                </fieldset>
              </td>
              <ng-template [ngIf]="offset == 0 || i < offset">
                <td *ngFor="let column of columnsVisible" style="padding: 0 0.3rem 0 0.3rem; cursor: pointer; vertical-align: middle;">
                  <fieldset class="form-group">
                    <div [ngSwitch]="column.datatype" (click)="getItemColumn([item],column)">
                      <div *ngSwitchCase="0" class="flex-{{column.align}} grid-col-data">{{returnData(item,column)}}</div>
                      <div *ngSwitchCase="1" class="flex-{{column.align}}">
                        <moment date="{{returnData(item,column)}}"></moment>
                      </div>
                      <div *ngSwitchCase="2" class="flex-{{column.align}}" style="margin-top: 0;">
                        <input type="checkbox" id="column.fieldName{{i}}" [(ngModel)]="item[column.fieldName]">
                        <label attr.for="column.fieldName{{i}}"></label>
                      </div>
                      <div *ngSwitchCase="3" class="flex-{{column.align}}">
                        <state [item]="item" value="{{returnData(item,column)}}" [options]="column.options"></state>
                      </div>
                      <div *ngSwitchCase="4" class="flex-{{column.align}}">
                        <glyph [item]="item" value="{{returnData(item,column)}}" [options]="column.options"></glyph>
                      </div>
                      <div *ngSwitchCase="5" class="flex-{{column.align}}">
                        <a href="{{returnData(item,column)}}" target="_blank">{{returnData(item,column)}}</a>
                      </div>
                      <div *ngSwitchCase="6" class="flex-{{column.align}}">
                        <a href="tel:{{returnData(item,column)}}">{{returnData(item,column)}}</a>
                      </div>
                      <div *ngSwitchCase="7" class="flex-{{column.align}}">
                        <a href="mailto:{{returnData(item,column)}}" style="color: -webkit-link;cursor: auto;text-decoration: underline;">{{returnData(item,column)}}</a>
                      </div>
                      <div class="text-right" (click)="getItem([item])" *ngSwitchCase="8">{{returnDataFloat(item,column)}}</div>
                      <div *ngSwitchCase="9" class="flex-{{column.align}}">
                        <input type="checkbox" id="{{column.fieldName}}{{i}}" [checked]="returnData(item,column)" [disabled]="true">
                        <label attr.for="{{column.fieldName}}{{i}}"></label>
                      </div>
                      <div *ngSwitchCase="10" class="flex-{{column.align}}">
                        <i class="fa-3x" [ngClass]="returnData(item,column)"></i>
                      </div>
                      <div *ngSwitchCase="11" class="flex-{{column.align}}">
                        <span style="height:100%;width: 100%;display:block;overflow:auto;" [ngStyle]="{'background-color': '#' + returnData(item,column)}">&nbsp;</span>
                      </div>
                    </div>
                  </fieldset>
                </td>
              </ng-template>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="loading" class="text-center" style="bottom: 2rem; position: relative;">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color: #007bff;"></i>
      </div>
      <nav *ngIf="!loading && !infinite && offset != 0">
        <div *ngIf="pagination.pages && pagination.totalItems > 0">
          <div class="pull-left" *ngIf="pagination.pages && pagination.pages.length > 1">
            <ul class="pagination pagination-sm">
              <li class="page-item" [ngClass]="{disabled:pagination.currentPage === 1}">
                <a class="page-link" aria-label="First" (click)="getItems(1,filter)">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [ngClass]="{disabled:pagination.currentPage === 1}">
                <a class="page-link" aria-label="Previous" (click)="getItems(page-1,filter)">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pagination.pages" [ngClass]="{active:pagination.currentPage === page}">
                <a class="page-link" (click)="getItems(page,filter)">{{page}}</a>
              </li>
              <li class="page-item" [ngClass]="{disabled:pagination.currentPage === pagination.totalPages}">
                <a class="page-link" aria-label="Next" (click)="getItems(page+1,filter)">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [ngClass]="{disabled:pagination.currentPage === pagination.totalPages}">
                <a class="page-link" aria-label="Last" (click)="getItems(pageNumber,filter)">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="pull-right">
            <ul class="pagination pagination-sm pull-right">
              <li class="page-item" *ngIf="count < 500" [ngClass]="{active:offset == 0}">
                <a class="page-link" aria-label="All" (click)="offsetChange(0)">
                  <span aria-hidden="true">All</span>
                </a>
              </li>
              <li class="page-item" [ngClass]="{active:offset == 5}">
                <a class="page-link" aria-label="5" (click)="offsetChange(5)">
                  <span aria-hidden="true">5</span>
                </a>
              </li>
              <li class="page-item" [ngClass]="{active:offset == 10}">
                <a class="page-link" aria-label="10" (click)="offsetChange(10)">
                  <span aria-hidden="true">10</span>
                </a>
              </li>
              <li class="page-item" [ngClass]="{active:offset == 20}">
                <a class="page-link" aria-label="20" (click)="offsetChange(20)">
                  <span aria-hidden="true">20</span>
                </a>
              </li>
              <li class="page-item" [ngClass]="{active:offset == 50}">
                <a class="page-link" aria-label="50" (click)="offsetChange(50)">
                  <span aria-hidden="true">50</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>`,
  styles: [`
  .card {
    margin-bottom: 1rem;
  }
  .grid-card-block {
      padding: 0px;
  }
  .card-modal {
      margin-bottom: 0px;
  }
  @media (max-width: 991px) { 
      .card {
          -webkit-border-radius: 0px;
          -moz-border-radius: 0px;
          -ms-border-radius: 0px;
          -o-border-radius: 0px;
          border-radius: 0px;
      }
      .card .card-header {
          -webkit-border-radius: 0px;
          -moz-border-radius: 0px;
          -ms-border-radius: 0px;
          -o-border-radius: 0px;
          border-radius: 0px;
      }
  }
  .form-header.grid-form-header {
      margin-bottom: 1rem;
      padding: 0.5rem;
  }
  .grid-search-input {
      display: inline-block;
      padding: 0;
      margin: 0;
  }
  .grid-small-device {
      padding: 0.5rem;
  }
  .grid-card-title {
      margin-top: 3px;
      margin-bottom: 2px;
      display: inline-table;
  }
  .navbar-btn {
      padding: .5rem 1rem;
      color: rgba(0, 0, 0, 0.54) !important;
  }
  .grid-card {
      padding-right: 0;
  }
  .grid-header {
      padding:.20rem;
      background-color: #FFF !important;
      width: 100%;
      display: block;
  }
  .grid-sm-row {
      margin: 15px 15px 0 0;
  }

  .grid-sm-col {
      padding: 0 0.5rem;
  }

  .table thead {
      background-color: #007bff !important;
  }

  .table thead th {
      color: white !important;
  }

  .grid-col-header {
      color: rgba(0, 0, 0, 0.54) !important;
      font-size: x-small;
      padding-right: 10px;
  }
  .grid-col-data {
      white-space: nowrap;
      text-overflow: ellipsis;
  }
  @media (max-width: 575px) { 
      .grid-title {
          margin-top: 0.1rem;
          font-size: 1rem;
      }
  }
  .table {
      margin-bottom: 0px;
  }
  .pagination {
      margin: 0.5rem;
  }
  .page-item {
      display: inline-block;
  }
  .select-wrapper input.select-dropdown {
      margin: 0px;
  } 
  .grid-selector {
      max-width: 90px;
  }

  .profil {
      padding: 1rem 0px;
      text-align: center;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      -ms-border-radius: 3px;
      -o-border-radius: 3px;
      border-radius: 3px;
      border: 1px solid rgba(0,0,0,.2);
  }
  [type="radio"]:checked + label, [type="radio"]:not(:checked) + label, [type="checkbox"] + label {
      padding-left: 0px;
      margin-left: 3px;
  }
  /*.grid-checkbox {
      width: 35px;
  }*/
  .table a {
      margin-left: 0px;
  }

  .page-item.active .page-link {
      background-color: #007bff;
  } 

  .mdb-skin input[type=checkbox]:checked+label:before {
      border-right: 2px solid #00C851;
      border-bottom: 2px solid #00C851;
  }  `],
  encapsulation: ViewEncapsulation.None,
  providers: [GenericdatasetService, GridService, PaginationService]
})

export class GridComponent extends UiComponent implements OnInit {
  @Input() public result: boolean = false;
  @Input() public name: string = 'grid';
  @Input() public actions: any[] = new Array<any>();
  @Input() public title: string = '';
  @Input() public parentId: any;
  @Input() public parentFieldName: string = '';
  @Input() public filter: any = '';
  @Input() public restName: string = '';
  @Input() public _href: string = '';
  @Input() public configPath: string = '';
  @Input() public visible: boolean = true;
  @Input() public autoSearch: boolean = false;
  @Input() public infinite: boolean = false;
  //@Input() public pagination: boolean = false;
  public pagination: any = {};
  @Input() public openMode: number;
  @Input() public glyph: string = '';
  @Input() public isCollapse: boolean = false;
  @Input() public templateNameRecord: string = '';
  @Input() public listFilter: string = '';
  @Input() public parameters: any;
  @Input() public createChoices: any;
  @Input() public initValue: any[] = new Array<any>();
  @Input() public showCreate: boolean = true;
  @Input() public showDelete: boolean = false;
  @Input() public showFilter: boolean = false;
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onGetItem: EventEmitter<any> = new EventEmitter();
  @Output() refreshed: EventEmitter<any> = new EventEmitter<any>();
  @Output() onInit: EventEmitter<any> = new EventEmitter<any>();
  @Input() public selectMultiple: boolean = false;
  public progress: number = 0;
  public loading: Boolean = false;
  public page: number = 1;
  public perPage: number = 0;
  public pageNumber: number = 0;
  public error: Error;
  public selectAll: Boolean = false;
  public selectAllAvailable: Boolean = false;
  public selectedItems: any[] = new Array<any>();
  public selectedItem: any;
  public inputRecord: Item;
  //public listFilter: HTMLInputElement;
  public offset: number = offsetDefault;
  public count: number = 0;
  items: any[] = new Array<any>();
  request: any = null;
  public columns: any[] = new Array<any>();
  public columnsVisible: any[] = new Array<any>();
  public columnsAvailable: any[] = new Array<any>();
  public offsetOption: any[] = new Array<any>();
  public page_size: string = '';
  public filterOption: any = { date: null };
  @Input() modal: boolean;
  @Input() focusOnInit: boolean = false;
  @ViewChild('offsetSelect') offsetSelect: ElementRef;
  @ViewChild('pageSelect') pageSelect: ElementRef;
  @ViewChild('filterinput') filterInput: DebounceinputComponent;
  public ref: any;
  public modalId: number;
  public searching: boolean = false;
  public timeToRender: number;
  @Input() footerVisible: boolean = false;
  /*private fileUploaderOptions: FileUploaderOptions = {
    url: 'http://ftp.odusseuserp.org/upload', //'http://localhost:3003/uploadhttp://ftp.odusseuserp.org/upload',
    //autoUpload: true,
  };
  public uploader: FileUploader = new FileUploader(this.fileUploaderOptions);*/

  constructor(
    injector: Injector,
    public renderer: Renderer,
    public gridService: GridService,
    public itemService: GenericdatasetService,
    //public hotkeysService: HotkeysService,
    public dataService: DataService,
    public paginationService: PaginationService,
    public reactiveformService: ReactiveformService) {
    super(injector);
    this.setTranslations(Translations);
    /*this.hotkeysService.add(new Hotkey('f3', (event: KeyboardEvent): boolean => {
      this.onCreate();
      return false;
    }));
    this.hotkeysService.add(new Hotkey('f5', (event: KeyboardEvent): boolean => {
      //COPY
      return false;
    }));
    this.hotkeysService.add(new Hotkey('f6', (event: KeyboardEvent): boolean => {
      this.deleteItemSelected();
      return false;
    }));*/
  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
    if (this.focusOnInit) {
      setTimeout(() => {
        this.renderer.invokeElementMethod(this.filterInput.input.nativeElement, 'focus');
      }, 1);
    }
  }

  ngOnInit(): void {
    if (this.openMode == null) {
      this.openMode = 0;
    }
    if (!this.configPath) {
      this.configPath = this._href;
    }
    this.offsetOption = [{ code: 'All', value: 0 }, { code: '5', value: 5 }, { code: '10', value: 10 }, { code: '20', value: 20 }, { code: '50', value: 50 }];
    const column: Column = new Column();
    column.name = 'idrUsersId';
    column.fieldName = 'idrUsersId';
    column.caption = 'idrUsersId';
    this.columnsAvailable.push(column);
    //override the onAfterAddingfile property of the uploader so it doesn't authenticate with //credentials.
    /*this.uploader.onAfterAddingFile = (file: any) => {
      file.withCredentials = false;
      this.uploadFile();
    };*/
    this.onInit.emit();
  }

  load() {
    this.timeToRender = new Date().getTime();
    this.itemService.setrestName(this.restName);
    if (this.columns && this.columns.length == 0) {
      this.gridService.setpath('./assets/data/json/list/fields/' + this.configPath.toLowerCase() + '.json');
      this.gridService.getJson().subscribe((data) => {
        this.request = this.setRequest(data);
        this.getItems(this.page, this.filter, true);
      }, (error) => {
        this.gridService.setpath('./assets/data/json/list/fields/default.json');
        this.gridService.getJson().subscribe((data) => {
          this.request = this.setRequest(data);
          this.getItems(this.page, this.filter, true);
        });
      });
    }
  }


  @Input() public set href(href: string) {
    this._href = href;
    if (!this.restName) this.restName = this._href;
  }

  public get href() {
    return this._href;
  }

  getFilterValue(): string {
    let value = '';
    if (this.listFilter != null) {
      value = this.listFilter;
    }
    return value;
  }

  getFilter(): string {
    return this.filter;
  }

  getPage(): number {
    return this.page;
  }

  filterChange(filter: string): void {
    this.listFilter = filter;
    this.items = [];
    this.offset = offsetDefault;
    this.timeToRender = new Date().getTime();
    if (this.pagination && this.autoSearch) {
      this.getItems(1, this.filter);
    }
  }

  clearFilter(): void {
    this.listFilter = '';
    if (this.pagination) {
      this.getItems(1, this.filter);
    }
  }

  showMore() {
    this.offset = this.offset + 15;
    //this.timeToRender = null; TODO
    this.getItems(1, this.filter);
  }

  ufColumnSum(column: any) {
    let sum: number = 0;
    let result: string;
    for (let i = 0; i <= this.items.length - 1; i++) {
      if (this.offset == 0 || i < this.offset) {
        const item: any = this.returnData(this.items[i], column);
        if (!((item == NaN) || (item == null) || (item == undefined) || (item == ''))) {
          sum = sum + item;
        }
      } else {
        break;
      }
    }
    if (column.options && column.options.precision) {
      result = sum.toFixed(column.options.precision);
    } else {
      result = sum.toString();
    }
    return result;
  }

  selectItem(item: Item): void {
    if (!item.selected) {
      const i = this.selectedItems.indexOf(item);
      if (i > - 1) {
        this.selectedItems.splice(i, 1);
      } else {
        this.selectedItems.push(item);
      }
    }
  }

  insertItem(): void {
    this.selectedItem = {};
  }

  /*applyFilter(filter: any): string {
    let filterTxt: string = '';
    if (filter != null && filter.length > 0) {
      for (let i = 0; i <= filter.length - 1; i++) {
        filterTxt = filterTxt + '&[where][' + filter[i].fieldName + ']=' + filter[i].value;//url = url + '&[where][and][' + i + '][' + filter[i].fieldName + ']=' + filter[i].value;
      }
      for (let i = 0; i < this.columns.length - 1; i++) {
      }
    }
    filterTxt = filterTxt + '?[where][active]=true';
    return filterTxt;
  }*/

  getItemsCount(first?: boolean): void {
    this.count = 0;
    if (!this.autoSearch) {
      return;
    }
    this.pageNumber = 1;
    //this.applyFilter(this.filter);
    if (!this.infinite) {
      this.itemService.getItemsCount(this.filter, this.request, this.listFilter)
        .subscribe(
        (items) => {
          this.count = items['count'];
          if ((first == true) && (this.count < 500)) {
            this.offset = 0;
          }
          if (this.offset != null && this.offset > 0) {
            this.pageNumber = this.count / this.offset;
            this.pageNumber = Math.ceil(this.pageNumber);
          }
          //this.pagination = this.paginationService.getPagination(this.count, this.page, this.offset)
          this.toto();
        }
        );
    } else {
      this.toto();
    }
  }

  toto() {
    this.loading = true;
    this.itemService.getItems(this.page, this.offset, this.filter, this.request, this.listFilter)
      .subscribe(
      (items) => {
        if (this.infinite) {
          for (let i: number = 0; i <= items.length - 1; i++) {
            let resultItem: boolean = true;
            for (let j: number = 0; j <= this.items.length - 1; j++) {
              resultItem = true;
              for (const propItems in items[i]) {
                if ((!(items[i][propItems] instanceof Object)) && (items[i][propItems] != this.items[j][propItems])) {
                  resultItem = false;
                  break;
                }
              }
              if (resultItem) {
                break;
              }
            }
            if ((this.items.length == 0) || !resultItem) {
              this.items.push(items[i]);
            }
          }
        } else {
          this.items = items;
        }
        for (let i = items.length - 1; i >= 0; i--) {
          for (let j = 0; j <= this.columns.length - 1; j++) {
            const result = this.returnData(items[i], this.columns[j]);
            if (!result) {
            }
            if (result == null) {
              this.items.splice(i, 1);
              break;
            }
          }
        }
        if (((this.items.length != this.count) && (this.offset == 0)) || this.infinite) {
          this.count = this.items.length;
        }
        this.pagination = this.paginationService.getPagination(this.count, this.page, this.offset);
        this.refreshed.emit(this.items);
      },
      (error) => {
        this.loading = false;
        this.error = error;
      },
      () => {
        this.loading = false;
        if (this.timeToRender) this.timeToRender = (new Date().getTime() - this.timeToRender) / 1000;
      });
  }

  returnDataFloat(item: any, column: any) {
    let result: any = this.returnData(item, column);
    if (result != '' && column.datatype == 8 && column.options && column.options.precision) {
      result = result.toFixed(column.options.precision);
    }
    return result;
  }

  returnData(item: any, column: any): any {
    let result: any;
    if (!column.includes) {
      result = item[column.fieldName];
      if (!result) {
        result = '';
      }
      return result;
    } else {
      result = item;
      //let include: boolean = false;
      for (let i: number = 0; i <= column.includes.length - 1; i++) {
        //include = true;
        result = result[column.includes[i]];
        if (result == null) {
          return result;
        }
      }
      if (result) {
        result = result[column.fieldName];
        if (!result) {
          result = '';
        }
      } else {
        result = '';
      }
      return result;
    }
  }

  refresh() {
    this.getItems(this.page, this.filter);
  }

  getItems(page: number, filter: string, first?: boolean): void {
    if (!this.autoSearch) {
      return;
    }
    this.page = page;
    this.filter = filter;
    this.getItemsCount(first);
  }

  getItemsFromFilter(dateType: number) {
    this.items = [];
    this.timeToRender = new Date().getTime();
    if (this.filterOption.date != dateType) {
      let date: Date = new Date();
      switch (dateType) {
        case 0: {
          date.setHours(date.getHours() - 1);
        }
          break;
        case 1: {
          date.setHours(0, 0, 0, 0);
        }
          break;
        case 2: {
          date.setDate(date.getDate() - date.getDay() + 1);
          date.setHours(0, 0, 0, 0);
        }
          break;
        case 3: {
          date.setDate(1);
          date.setHours(0, 0, 0, 0);
        }
          break;
        case 4: {
          date.setMonth(0);
          date.setDate(1);
          date.setHours(0, 0, 0, 0);
        }
          break;
        default: return;
      }
      this.filter = [{ operator: 'gte', fieldName: 'c_date', value: date }];
      this.filterOption.date = dateType;
    } else {
      this.filterOption.date = null;
    }
    this.getItems(this.page, this.filter, false);
  }

  close(id: any) {
    //this.placeholderService.closeModal(this.modalId);
    this.getItems(this.page, this.filter);
  }

  closeModal() {
    this.onClose.emit();
  }

  getItem(item: [any]) {
    this.onGetItem.emit(item);
    this.getItemDefault(item, this.templateNameRecord);
  }

  getItemColumn(item: [any], column: Column) {
    switch (column.datatype) {
      case 5: { }
      case 6: { }
      case 7: { }
        break;
      default: {
        this.getItem(item);
      }
    }
  }

  getItemDefault(item: [any], templateNameRecord: string) {
    if (this.modal) {
      this.onClose.emit(item);
    } else {
      this.openItem(item, {}, templateNameRecord);
    }
  }

  openItem(item: [any], parameters: any, templateNameRecord: string) {
    if (/*this.modal || */this.openMode == 2) {
      parameters['modal'] = true;
      parameters['close'] = (id: any) => {
        this.close(id);
        if ((id > 111) && this.modal) {
          this.getItem([{ id }]);
        }
      };
      parameters['options'] = {};
      parameters['id'] = item[0].id;
      if (templateNameRecord == 'Generic') {
        parameters.options = { restName: this.restName, glyph: this.glyph, title: this.title, backLink: this.restName };
      }
      //this.modalId = this.placeholderService.addModal(templateNameRecord, parameters);
    } else {
      this.reactiveformService.backLink = this.router.url;
      if (this.modal) {
        this.onClose.emit();
      }
      this.dataService.setStorage(parameters);
      let route = ['/', this.href, item[0].id];
      if (templateNameRecord) {
        route = ['/', this.href, templateNameRecord, item[0].id];
      }
      this.router.navigate(route);
    }
  }

  onSelect(item: any): void {
    this.selectedItem = item;
  }

  onselectAll(): void {
    this.items.forEach((item) => {
      if (!item.locked) {
        item.selected = !this.selectAll;
      }
    });
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      if (this.items.length == 1) {
        this.getItem([this.items[0]]);
      }
    } else if (event.keyCode == 46) {
      this.filterInput.clear();
    }
    /*if (event.keyCode == 8 || event.keyCode == 46) {
      this.clear();
    }
    else if (event.keyCode != 9) {
      if (this.id > idEmpty) {
        this.openRecord();
      } else {
        this.openList(event.key);
      }
    }*/
  }

  onselectAllAvailable(): void {
    this.columnsAvailable.forEach((column) => {
      column.selected = !this.selectAllAvailable;
    });
  }

  onOrderBy(column: Column): void {
    if (column.orderBy == 0 || column.orderBy == 1) {
      column.orderBy = column.orderBy + 1;
    } else {
      column.orderBy = 0;
    }
    if (column.orderBy == 1) {
      column.orderByCode = '+';
    } else if (column.orderBy == 2) {
      column.orderByCode = '-';
    }
    this.getItems(1, this.filter);
  }

  onClickAutoSearch(): void {
    this.autoSearch = !this.autoSearch;
    if (this.autoSearch) {
      this.getItems(this.page, this.filter);
    }
  }

  add(name: string): void {
    if (!name) { return; }
    this.itemService.addItem(name)
      .subscribe(
      (item) => this.items.push(item),
      (error) => this.error = error as any);
    //this.inputRecord = null; TODO
  }

  deleteItemSelected() {
    const deleteItems = this.items
      .filter((item) => item.selected == true);
    this.deleteItems(deleteItems);
    this.selectAll = false;
  }

  getItemSelected(): any {
    const itemsSelected = this.items
      .filter((item) => item.selected == true);
    return itemsSelected;
  }

  deleteItems(items: Item[]) {
    items.reverse();
    this.progress = 0;
    const i: number = 0;
    items.forEach((item) => {
      this.delete(item, i, items.length);
    });
  }

  delete(item: any, i: number, length: number) {
    const id = item['id'];
    this.itemService.setrestName(this.restName);
    this.itemService.getItem(id)
      .subscribe((result) => {
        this.itemService
          .deleteItem(result, id)
          .subscribe(
          (item) => {
            this.progress = this.progress + 1;
            if (this.progress == length) {
              this.getItems(this.page, this.filter);
            }
          },
          (error) => this.progress = this.progress + 1);
      });

    this.selectedItem = null;
  }

  update(item: any) {
    const id = item['id'];
    this.itemService
      .updateItem(item, id)
      .subscribe();
  }

  numberToArray(): number[] {
    if (this.offset == 0) {
      const array: any[] = [];
      array.push({ code: '1', value: 1 });
      return array;
    }
    const array: any[] = [];
    const pageNumber: number = Math.ceil(this.count / this.offset);
    for (let i = 0; i < pageNumber; i++) {
      array.push({ code: i + 1, value: i + 1 });
    }
    return array;
  }

  setRequest(request: any): any {
    if (request) {
      this.columns = this.setColumns(request.columns);
    } else {
      this.columns = [];
    }
    this.request = request;
    return request;
  }

  setColumns(dataColumns: any): any {
    const columns: any[] = [];
    for (let i = 0; i <= dataColumns.length - 1; i++) {
      if (dataColumns[i].visible == null) {
        dataColumns[i].visible = true;
      }
      if (dataColumns[i].orderBy == null) {
        dataColumns[i].orderBy = 0;
      }
      if (dataColumns[i].orderByCode == null) {
        dataColumns[i].orderBy = '+';
      }
      if (dataColumns[i].datatype == null) {
        dataColumns[i].datatype = 0;
      }
      if (dataColumns[i].selected == null) {
        dataColumns[i].selected = false;
      }
      if (dataColumns[i].visible) {
        this.columnsVisible.push(dataColumns[i]);
      }
      columns.push(dataColumns[i]);
    }
    return dataColumns;
  }

  orderBy(): String[] {
    const orderBy: String[] = [];
    for (let i = 0; i < this.columns.length - 1; i++) {
      if (this.columns[i].orderByCode != null) {
        orderBy.push(this.columns[i].orderByCode + this.columns[i].name);
      }
    }
    return orderBy;
  }

  onCollapse() {
    this.isCollapse = !this.isCollapse;
  }

  onCreateParameters(parametersSend: any) {
    const item: any = {};
    const parameters: any = {};
    let templateNameRecord: string = this.templateNameRecord;
    parameters['initValue'] = [parametersSend];
    if (parametersSend['templateNameRecord'] != null) {
      templateNameRecord = parametersSend['templateNameRecord'];
    }
    item['id'] = 0;
    if (this.parentId != null) {
      item[this.parentFieldName] = this.parentId;
      parameters['initValue'].push({ parentFieldName: this.parentFieldName, parentId: this.parentId });
    }
    this.openItem([item], parameters, templateNameRecord);
  }

  onCreate() {
    const item: any = {};
    const parameters: any = {};
    item['id'] = 0;
    if (this.parentId != null) {
      item[this.parentFieldName] = this.parentId;
      parameters['initValue'] = [{ parentFieldName: this.parentFieldName, parentId: this.parentId }];
    }
    if (this.initValue && this.initValue.length > 0) {
      parameters['initValue'] = this.initValue;
    }
    this.openItem([item], parameters, this.templateNameRecord);
  }

  offsetChange($event: any) {
    this.offset = $event;
    this.getItems(1, this.filter);
  }

  pageChange($event: any) {
    this.page = $event;
    this.getItems(this.page, this.filter);
  }

  addColumn() {
    const columnsSelected = this.columnsAvailable
      .filter((column) => column.selected == true);
    this.columnsAvailable = this.columnsAvailable
      .filter((column) => column.selected == false);
    columnsSelected.forEach((item) => {
      item.selected = false;
    });
    this.columns.push.apply(this.columns, columnsSelected);
    this.selectAllAvailable = false;
    this.getItems(this.page, this.filter);
  }

  deleteColumn() {
    const columnsSelected = this.columns
      .filter((column) => column.selected == true);
    this.columns = this.columns
      .filter((column) => column.selected == false);
    columnsSelected.forEach((item) => {
      item.selected = false;
    });
    this.columnsAvailable.push.apply(this.columnsAvailable, columnsSelected);
    this.getItems(this.page, this.filter);
  }

  getColumnDisplayed(): number {
    const columnsSelected = this.columns
      .filter((column) => column.selected == true);
    return columnsSelected.length;
  }

  getColumnAvailableSelected(): number {
    const columnsSelected = this.columnsAvailable
      .filter((column) => column.selected == true);
    return columnsSelected.length;
  }

  upColumn() {
    //let columnsSelected = this.columns
    //.filter(column => column.selected == true);
    /*let i: number = 0;
    this.columns.forEach((item) => {
      if (item.selected) {
        this.move(this.columns,i,i - 1);
      }
      i++;
    });*/
  }

  downColumn() {
    /*let i: number = 0;
    for (let i: number = this.columns.length - 1; i >=0 ; i--)
      if (this.columns[i].selected) {
        //this.columns.copyWithin() .move(this.columns,i,i + 1);
      }
      i++;
    });*/
  }

  openGridPreferences() {
    let parameters;
    parameters = {
      modal: true,
      grid: this
    };
    //this.modalId = this.placeholderService.addModal('GridPreferenceModule', parameters, 'Preferences', 'modal-bf-fh');
  }

  setVisible(visible: boolean) {
    this.visible = visible;
  }

  public uploadFile(): void {
    //this.uploader.uploadAll();
  }

  public displaySearch(): void {
    this.searching = true;
  }

  onScroll($event: any) {
    if (!this.modal && this.infinite) {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        this.showMore();
        //Write logic here for loading new content.
      }
    }
  }
}
